var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Warstwa_2","data-name":"Warstwa 2","transform":"translate(0.144 0.213)"},React.createElement("g",{"id":"Warstwa_1","data-name":"Warstwa 1","transform":"translate(-0.144 -0.213)"},React.createElement("path",{"id":"Path_1662","data-name":"Path 1662","d":"M12.89-.173A4.868,4.868,0,0,0,8.825,2.01a4.877,4.877,0,1,0-7.638,6l7.638,7.649,7.647-7.638a4.877,4.877,0,0,0-3.582-8.2Z","transform":"translate(0.144 0.213)","fill":"#14171c"}))));
}

Heart.defaultProps = {"width":"17.921","height":"15.875","viewBox":"0 0 17.921 15.875"};

module.exports = Heart;

Heart.default = Heart;
